var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinueSf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54209 18.9342C6.07278 22.7292 10.3566 26.9182 16.9999 31.3092C23.6432 26.9182 27.927 22.7292 30.4577 18.9342H25.2499C25.044 18.9342 24.8427 18.8725 24.6722 18.757C24.5016 18.6416 24.3695 18.4778 24.2929 18.2866L21.2878 10.775L17.992 22.3105C17.933 22.5174 17.8109 22.7007 17.6426 22.8347C17.4743 22.9687 17.2684 23.0468 17.0536 23.0579C16.8387 23.069 16.6258 23.0127 16.4446 22.8968C16.2634 22.7809 16.1229 22.6113 16.0429 22.4116L12.646 13.9182L9.6079 18.4763C9.51358 18.6173 9.38593 18.7329 9.23627 18.8128C9.0866 18.8926 8.91954 18.9344 8.7499 18.9342H3.54209ZM2.31284 16.8717C-4.50372 3.83672 9.59553 -3.75328 16.6369 2.72916C16.7606 2.84259 16.8823 2.96016 16.9999 3.08184C17.1163 2.96027 17.2374 2.8433 17.3629 2.73122C24.4043 -3.75328 38.5035 3.83672 31.6849 16.8717H25.945L22.0798 7.20684C21.9998 7.00716 21.8594 6.8375 21.6782 6.72161C21.4969 6.60572 21.284 6.54941 21.0692 6.56055C20.8543 6.57169 20.6484 6.64972 20.4801 6.78374C20.3119 6.91775 20.1897 7.10102 20.1308 7.30791L16.837 18.8435L13.8319 11.3318C13.7619 11.1576 13.6457 11.0058 13.4957 10.8927C13.3458 10.7797 13.1678 10.7097 12.981 10.6904C12.7942 10.6711 12.6057 10.7031 12.4358 10.7831C12.2659 10.8631 12.1211 10.9879 12.0169 11.1442L8.19715 16.8717H2.3149H2.31284Z",
    fill: "#AA30C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinueSf);
export default __webpack_public_path__ + "static/media/continue_sf.1b5b6cf43ccf27fa3d414561efbb4a3d.svg";
export { ForwardRef as ReactComponent };